import {
  IconBasketAdd,
  IconGift,
  IconPen,
  IconPlusRounded,
  IconTrash,
} from "@aksara-ui/icons";
import {
  TableHeadRow,
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableHead,
  Text,
  TableHeadCell,
  TableBody,
  TableBodyRow,
  TableBodyCell,
  Badge,
  IconButton,
  theme,
} from "@aksara-ui/react";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import {
  getAllTenantsFilter,
  getAllReward,
  setModalConfirmationOpen,
  setModalDescriptionOpen,
  setModalFormOpen,
} from "redux/actions";
import styled from "styled-components";
import {
  VoucherFormModal,
  VoucherConfirmationModal,
  VoucherDescriptionFormModal,
  RaffleLuxuryModal,
} from "./components";
import moment from "moment";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import { CatalogStocksContent } from "modules/Catalogs/CatalogStocks";
import { InputSearchbox } from "components/Form/InputSearchbox";
import FilterKit from "components/FilterKit";
import { getRole } from "hooks";
import LazyLoadImageWithBlurHash from "components/LazyLoadImageWithBlurHash";
import { Link } from "react-router-dom";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 20px;
`;

const RaffleAncolContent: React.FC = () => {
  const dispatch = useDispatch();
  const userRole = getRole();
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  const {
    appUrl,
    isLoading,
    isModalFormOpen,
    isModalConfirmationOpen,
    isModalDescriptionOpen,
  } = useSelector((state: any) => state.globalReducer);

  const { vouchers, currentPage, totalPage, limitPage, lengthPage, filterTenantPage } =
    useSelector((state: any) => state.voucherReducer);

  const { tenantsFilter } = useSelector((state: any) => state.tenantReducer);

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);
  const [selectedVoucherId, setSelectedVoucherId] = useState("");
  const [modalVoucherStocksOpen, setModalVoucherStocksOpen] = useState(false);
  const [modalReleaseVoucherOpen, setModalReleaseVoucherOpen] = useState(false);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(
      getAllReward(2, event.target.value, limitPage, filterTenantPage) as any
    );
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(
      getAllReward(2, "", limitPage, filterTenantPage) as any
    );
  };

  const handleOpenFormModal = (voucherId: string = "") => {
    dispatch(setModalFormOpen(true) as any);
    setSelectedVoucherId(voucherId);
  };

  const handleCloseFormModal = () => {
    dispatch(setModalFormOpen(false) as any);
    setSelectedVoucherId("");
  };

  const handleOpenConfirmModal = (voucherId: string) => {
    dispatch(setModalConfirmationOpen(true) as any);
    setSelectedVoucherId(voucherId);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
    setSelectedVoucherId("");
  };

  const handleOpenVoucherStocksModal = (voucherId: string) => {
    setModalVoucherStocksOpen(true);
    setSelectedVoucherId(voucherId);
  };

  const handleCloseVoucherStocksModal = () => {
    setModalVoucherStocksOpen(false);
    setSelectedVoucherId("");
  };

   const handleOpenVoucherDescriptionFormModal = (catalogId: string) => {
     dispatch(setModalDescriptionOpen(true) as any);
     setSelectedVoucherId(catalogId);
   };
 
   const handleCloseVoucherDescriptionFormModal = () => {
     dispatch(setModalDescriptionOpen(false) as any);
     setSelectedVoucherId("");
   };

  /** 🔥 RELEASE → RAFFLE */
  const handleOpenReleaseVoucherModal = (voucherId: string) => {
    setModalReleaseVoucherOpen(true);
    setSelectedVoucherId(voucherId);
  };

  const handleCloseReleaseVoucherModal = () => {
    setModalReleaseVoucherOpen(false);
    setSelectedVoucherId("");
  };

  useEffect(() => {
    dispatch(getAllTenantsFilter() as any);
    dispatch(getAllReward() as any);
  }, [dispatch]);

  return (
      <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
         <HeaderWrapper
           display={"flex"}
           flexDirection={"column"}
           style={{ gap: 20 }}
      >
           <Box display={"flex"}>
             <Text scale={[500, 600]} fontWeight={700}>
               Raffle Monthly
             </Text>
           </Box>
   
           <Box
             display={"flex"}
             flexDirection={isMobile ? "column" : "row"}
             justifyContent={"space-between"}
             style={{ gap: isMobile ? 10 : 20 }}
           >
             <Box
               display={"flex"}
               flexDirection={isTablet ? "column" : "row"}
               justifyContent={"space-between"}
               style={{ gap: 5 }}
             >
               <InputSearchbox
                 autoComplete="off"
                 name="textDummy"
                 placeholder="Search..."
                 size={32}
                 onChange={handleSearchChange}
                 onClearButton={handleClearSearchChange}
               />

            {userRole === "superadmin" && (
              <FilterKit
                orderByOptions={[
                  {
                    key: tenantsFilter,
                    label: "Tenant",
                    options: tenantsFilter.map((tenant: any) => ({
                      label: tenant.name,
                      value: tenant.id,
                    })),
                  },
                ]}
                onChangeOrder={(e: any) =>
                  dispatch(
                    getAllReward(
                      2,
                      "",
                      limitPage,
                      e[tenantsFilter]?.value || ""
                    ) as any
                  )
                }
              />
            )}
          </Box>
              <Stack
                display={"flex"}
                justifyContent={"right"}
                flexDirection={"row"}
                style={{ gap: isMobile ? 10 : 20 }}
              >
              <Button
                variant="primary"
                borderRadius={10}
                icon={IconPlusRounded}
                size={32}
                onClick={() => handleOpenFormModal()}
              >
                Add Voucher
              </Button>
              </Stack>  
        </Box>
      </HeaderWrapper>

      <Card overflow={"auto"} elevation={2} maxHeight={"100%"}>
        <Table>
            <TableHead
              position={"sticky"}
              top={0}
              backgroundColor={theme.colors.grey02}
            >
            <TableHeadRow>
              <TableHeadCell>Voucher Name</TableHeadCell>
              <TableHeadCell>Image</TableHeadCell>
              <TableHeadCell>Merchant</TableHeadCell>
              <TableHeadCell>Points Needed</TableHeadCell>
              <TableHeadCell>Available Stock</TableHeadCell>
              <TableHeadCell>Expiry Date</TableHeadCell>
              <TableHeadCell>Detail Winner</TableHeadCell>
              <TableHeadCell>Start Raffle</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
            <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={7} />
              ) : !vouchers.length ? (
                <TableBodyRow>
                  <TableBodyCell colSpan={7} textAlign={"center"}>
                    No data available in table
                  </TableBodyCell>
                </TableBodyRow>
              ) :  (
              vouchers.map((voucher: any) => (
                <TableBodyRow key={voucher.id}>
                  <TableBodyCell  onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                    style={{ cursor: "pointer" }}
                  >{voucher.catalog_name}
                  </TableBodyCell>
                  <TableBodyCell>
                    <LazyLoadImageWithBlurHash
                      src={`${appUrl}/storage/${voucher.img_url}`}
                      width={140}
                      style={{ borderRadius: 10 }}
                    />
                  </TableBodyCell>
                  <TableBodyCell  onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                    style={{ cursor: "pointer" }}
                  >
                    <Badge>{voucher.catalog_product}</Badge>
                  </TableBodyCell>
                  <TableBodyCell>
                    <Badge variant="info">
                      {voucher.points_needed.toLocaleString()} Pts
                    </Badge>
                  </TableBodyCell>
                  <TableBodyCell  onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                    style={{ cursor: "pointer" }}
                  >
                    <Badge>{voucher.available_stock}</Badge>
                  </TableBodyCell>
                  <TableBodyCell  onClick={() =>
                        handleOpenVoucherDescriptionFormModal(voucher.id)
                      }
                    style={{ cursor: "pointer" }}
                  >
                    {moment(voucher.expiry_date).format("DD MMM YYYY")}
                  </TableBodyCell>
                      <TableBodyCell whiteSpace={"nowrap"} textAlign={"center"}>
                          <Link to={`/products/gifts/${voucher.id}`}>
                            <IconButton
                              borderRadius={50}
                              size={32}
                              style={{
                                fontWeight: 600,
                                backgroundColor: theme.colors.blue06,
                              }}
                              type={"button"}
                            >
                              <IconGift fill={"white"} />
                            </IconButton>
                          </Link>
                      </TableBodyCell>
                  <TableBodyCell textAlign="center">
                    <IconButton
                      style={{ backgroundColor: theme.colors.blue06 }}
                      onClick={() =>
                        handleOpenReleaseVoucherModal(voucher.id)
                      }
                    >
                      <IconGift fill="white" />
                    </IconButton>
                  </TableBodyCell>

                  <TableBodyCell>
                    <IconButton
                      onClick={() =>
                        handleOpenVoucherStocksModal(voucher.id)
                      }
                    >
                      <IconBasketAdd />
                    </IconButton>
                    <IconButton onClick={() => handleOpenFormModal(voucher.id)}>
                      <IconPen />
                    </IconButton>
                    <IconButton
                      onClick={() => handleOpenConfirmModal(voucher.id)}
                    >
                      <IconTrash />
                    </IconButton>
                  </TableBodyCell>
                </TableBodyRow>
              ))
            )}
          </TableBody>
        </Table>
      </Card>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllReward(
                select,
                searchValue,
                limitPage,
                filterTenantPage
              ) as any
            )
          }
        />

        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllReward(
                  2,
                  searchValue,
                  selectedItem,
                  filterTenantPage
                ) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>

      {/* MODALS */}
      <VoucherFormModal
        voucherId={selectedVoucherId}
        isOpen={isModalFormOpen}
        onClose={handleCloseFormModal}
      />

      <VoucherConfirmationModal
        voucherId={selectedVoucherId}
        isOpen={isModalConfirmationOpen}
        onClose={handleCloseConfirmModal}
      />

      <VoucherDescriptionFormModal
        voucherId={selectedVoucherId}
        isOpen={isModalDescriptionOpen}
        onClose={handleCloseVoucherDescriptionFormModal}
      />

      <CatalogStocksContent
        catalogId={selectedVoucherId}
        type="Voucher"
        isOpen={modalVoucherStocksOpen}
        onClose={handleCloseVoucherStocksModal}
      />

      <RaffleLuxuryModal
        catalogId={selectedVoucherId}
        isOpen={modalReleaseVoucherOpen}
        vouchers={vouchers}
        onClose={handleCloseReleaseVoucherModal}
      />
    </Box>
  );
};

export default RaffleAncolContent;
